{
    "webshop_offer_voucher_correctCode": "Zadal si správny kód",
    "webShop_howToFindId_desc": "Svoje osobné ID nájdeš v profile hráča, kde ho môžeš skopírovať.",
    "webShop_howToFindId_link": "Kde nájdem svoje osobné ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Kód nie je správny",
    "webshop_offer_voucher_enterYourCode": "Zadaj svoje osobné ID",
    "webShop_unexpectedError_desc": "Vyskytla sa neočakávaná chyba, skús to znova neskôr.",
    "webShop_accountBanned_desc": "Konto je zablokované!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Zmluvné podmienky",
    "webshop_purchase_privacyPolicy": "Ochrana osobných údajov",
    "webshop_legal_1": "Právne informácie",
    "webshop_support_1": "Podpora",
    "mbs_access_welcome_desc": "Vitaj, {0}",
    "btn_login": "Prihlásenie",
    "mbs_access_error_sessionExpired_desc": "Čas tejto relácie uplynul. Zadaj ID svojho konta ručne."
}
